import { TWO_PERCENT } from "../../constants/variable";
import { QualityAssuranceData } from "../../types/TransactionSummary";
import { AmountIcon, EyeIcon, FeesIcon } from "../Icons";
import InputWithLabel from "../InputWithLabel";

export default function QualityAssuranceService({
  qualityAssuranceData,
}: {
  qualityAssuranceData: QualityAssuranceData;
}) {
  return (
    <section>
      <div className="flex justify-between items-start py-4">
        <div className="flex items-start">
          <div className="w-[200px]">
            <h3 className="text-lg font-semibold text-custom-dark-blue-new">
              Quality Assurance
            </h3>
            <p className="text-sm text-gray-500">Taram</p>
          </div>

          <div className="space-y-4">
            <div className="flex items-center gap-2">
              <p className="flex items-center gap-1 border rounded-md border-gray-300 bg-gray-50 px-3 py-1">
                <AmountIcon className="size-4" />{" "}
                <span className="text-gray-500">Amount:</span> $
                {qualityAssuranceData.qa_consignment_value}
              </p>

              <p className="flex items-center gap-1 border rounded-md border-gray-300 bg-gray-50 px-3 py-1">
                <FeesIcon className="size-4" />{" "}
                <span className="text-gray-500">Fee:</span> $
                {Number(qualityAssuranceData.loading_consignment_value) *
                  TWO_PERCENT}
              </p>
            </div>
          </div>
        </div>

        <div className="flex items-center gap-3">
          <button className="flex items-center gap-1 text-custom-blue-new border border-custom-blue-new px-3 py-2 rounded-lg">
            <EyeIcon className="size-5" /> View Detail
          </button>
          <span
            className={`text-sm font-medium px-3 py-1 rounded-xl ${
              status === "Approved"
                ? "bg-green-50 text-green-500 border border-green-400"
                : "bg-gray-50 text-gray-500 border border-gray-400"
            }`}
          >
            ↑ {qualityAssuranceData.status || "Processing"}
          </span>
        </div>
      </div>
      <AdminQAForm />

      <div className="ml-[200px] space-x-3">
        <button className="bg-red-100 text-red-500 text-sm px-3 py-1 border border-red-500 rounded-xl">
          Deny
        </button>
        <button className="bg-green-100 text-green-500 text-sm px-3 py-1 border border-green-500 rounded-xl">
          Approve
        </button>
      </div>
    </section>
  );
}

function AdminQAForm() {
  return (
    <form>
      <div className="grid items-center grid-cols-[185px_200px_200px_150px_150px] gap-4">
        <InputWithLabel label="" type="text" placeholder="Enter Quote Name" />
        <InputWithLabel label="" type="text" placeholder="Enter Quote Amount" />
        <InputWithLabel label="" type="text" placeholder="Enter ETA Days" />
        <input type="file" placeholder="Upload Quotes" className="hidden" />
        <button
          type="button"
          className="-mt-2 flex items-center gap-1 text-custom-blue-new border border-custom-blue-new px-3 py-2 rounded-lg"
        >
          Upload Quotes
        </button>

        <button
          type="button"
          className="ml-2 -mt-2 flex items-center gap-1 text-custom-blue-new border border-custom-blue-new px-3 py-2 rounded-lg"
        >
          <EyeIcon className="size-5" /> View Detail
        </button>
      </div>

      <div className="flex justify-end">
        <button
          type="submit"
          // disabled={isSubmitting}
          className="px-3 py-2 rounded-md bg-custom-blue-medium text-white font-medium"
        >
          {false ? "submitting.." : "Submit"}
        </button>
      </div>
    </form>
  );
}
